export default {
  state: {
    exclusive: {
      list: [],
      loading: false,
      selected: [],
    }
  },
  mutations: {
    setExclusiveDetails (state, data) {
      for (let field in data) {
        state.exclusive[field] = data[field]
      }
    }
  }
}


// WEBPACK FOOTER //
// ./src/store/runs/exclusive.js